export default "__VITE_ASSET__c60b5b05__"